
import {
  defineComponent, ref, watch, onMounted,
} from 'vue';
import ProgressSpinner from 'primevue/progressspinner';
import Image from 'primevue/image';
import { generateSha1HashWithSalt } from '@/helpers';
import { MEDIA_URL_ELEMENT_THUMB_GENERATION } from '@/components/template-builder/utils/constants';

export default defineComponent({
  name: 'TemplateElementsPreviewImage',

  components: {
    ProgressSpinner,
    Image,
  },

  props: {
    itemId: {
      type: String,
      required: true,
    },

    idShop: {
      type: Number,
      required: true,
    },

    maxRetries: {
      type: Number,
      default: 30,
    },

    retryDelay: {
      type: Number,
      default: 1000,
    },
  },

  setup(props) {
    const isLoading = ref(true);
    const hasImage = ref(false);
    const retryCount = ref(0);

    const generateImageUrl = () => {
      const sha1Key = generateSha1HashWithSalt(props.itemId, 'salt-');
      return `${MEDIA_URL_ELEMENT_THUMB_GENERATION
        .replace('{SHA1_KEY}', sha1Key)
        .replace('{ID_SHOP}', String(props.idShop))}&t=${new Date().getTime()}`;
    };

    const imageUrl = ref(generateImageUrl());

    const reGenerateUrl = () => {
      imageUrl.value = generateImageUrl();
    };

    const onImageLoaded = () => {
      isLoading.value = false;
      hasImage.value = true;
      retryCount.value = 0;
    };

    const onImageError = () => {
      hasImage.value = false;

      // Retry loading image
      if (retryCount.value < props.maxRetries) {
        retryCount.value += 1;
        setTimeout(() => {
          reGenerateUrl();
        }, props.retryDelay);
      } else {
        isLoading.value = false;
      }
    };

    // Watch for itemId changes to regenerate URL
    watch(() => props.itemId, () => {
      isLoading.value = true;
      hasImage.value = false;
      retryCount.value = 0;
      reGenerateUrl();
    });

    onMounted(() => {
      // Start loading immediately if we have an itemId
      if (props.itemId) {
        reGenerateUrl();
      }
    });

    return {
      isLoading,
      imageUrl,
      onImageLoaded,
      onImageError,
    };
  },
});
